<template lang="html">
  <v-container>
    <!-- ROLES + PERMISSIONS CONFIGURATION -->
    <v-row>
      <v-col class="xs-12">
        <v-card class="mb-10">
          <v-toolbar>
            <v-toolbar-title class="ml-3 mr-3" style="display: flex; width: 100%;">
              Project Role Templates
              <v-text-field
                v-model="ppermission_search"
                label="Filter Business Permissions"
                single-line
                hide-details
                class="ml-3"
                style="width: 200px;"
              ></v-text-field>
            </v-toolbar-title>
          </v-toolbar>
          <v-list>
            <v-list-group
              v-for="(bproletemplate, bproletemplate_index) in getUObjects({type: 'bproletemplates', ids: getUObject({type: 'businesses', id: getBusiness.id}).bproletemplates})"
              :key="`bproletemplates${bproletemplate.id}`"
              :value="bproletemplate_show_index === bproletemplate_index"
              @input="bproletemplate_show_index = bproletemplate_index"
              no-action
            >
              <template #prependIcon>
                <v-list-item-action>
                  <v-btn icon @click.stop="add_is_active = !add_is_active">
                    <v-icon color="green">mode_edit</v-icon>
                  </v-btn>
                </v-list-item-action>
              </template>
              <template #appendIcon>
                <v-list-item-action v-if="hasBusinessPermission('Delete Roles')" style="display: flex;flex-direction: row;">
                  <ButtonOutlined
                    value="Remove All"
                    color="warning"
                    width="80"
                    height="40"
                    text_size="8"
                    padding="3"
                    class="mr-3"
                    @click.native.stop="removeAllPermissions(bproletemplate)"
                  />
                  <ButtonOutlined
                    value="Add All"
                    color="success"
                    width="80"
                    height="40"
                    text_size="8"
                    padding="3"
                    class="mr-3"
                    @click.native.stop="addAllPermissions(bproletemplate)"
                  />
                  <StandardDeleteBtn @deleteClick="deleteUObject({
                      url: [
                        { businesses: getBusiness.id },
                        { bproletemplates: bproletemplate.id }
                      ]
                    })" />
                    <v-btn @click.stop="updateInBusinessProjects({business_id: getBusiness.id, bproletemplate_id: bproletemplate.id})" medium>Update Project Roles</v-btn>
                </v-list-item-action>
              </template>

              <template v-slot:activator>
                <v-list-item-content>
                  <v-list-item-title v-text="bproletemplate.name"></v-list-item-title>
                  <v-list-item-subtitle v-text="bproletemplate.description"></v-list-item-subtitle>
                </v-list-item-content>
              </template>
              <v-list-item
                v-for="ppermission in getUObjects({type: 'allppermissions'}).filter(ppermission => ppermission.name.toLowerCase().includes(ppermission_search.toLowerCase()))"
                :key="`ppermissions${ppermission.id}`"
                style="cursor: pointer;"
                :class="bproletemplate.ppermissions.indexOf(ppermission.id) !== -1 ? 'green' : ''"
                @click="
                bproletemplate.ppermissions.indexOf(ppermission.id) !== -1 ? 
                  removePPermissionToTemplate({business_id: getBusiness.id, bproletemplate_id: bproletemplate.id, ppermission_id: ppermission.id}) : 
                  addPPermissionToTemplate({business_id: getBusiness.id, bproletemplate_id: bproletemplate.id, ppermission_id: ppermission.id})"
              >
                <v-list-item-icon><v-icon v-if="bproletemplate.ppermissions.indexOf(ppermission.id) !== -1">done</v-icon></v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title v-text="ppermission.name"></v-list-item-title>
                  <v-list-item-subtitle v-text="ppermission.description"></v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list-group>
            <v-list-item v-if="hasBusinessPermission('Update Roles')">
              <v-list-item-icon>
                <v-icon v-if="!add_is_active" @click="add_is_active = true">add</v-icon>
                <v-icon v-if="add_is_active" @click="addNewRole()" color="green">send</v-icon>
              </v-list-item-icon>
              <v-list-item-content v-if="hasBusinessPermission('Add Roles') && !add_is_active" @click="add_is_active = true" style="cursor: pointer;">
                <v-list-item-title>NEW.role</v-list-item-title>
                <v-list-item-subtitle>Create a new project role.</v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-content v-if="hasBusinessPermission('Add Roles') && add_is_active">
                <v-list-item-title>
                  <StandardDataField text_color="snow" placeholder="ROLE.name" :value="new_role_name" @changeValue="new_role_name = $event" />
                </v-list-item-title>
                <v-list-item-subtitle>
                  <StandardDataField text_color="snow" placeholder="ROLE.description" :value="new_role_description" @changeValue="new_role_description = $event" />
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
      </v-col>
    </v-row>

  </v-container>
</template>

<script>

import ButtonOutlined from '@/components/WorkPackageWIP/ButtonOutlined.component.vue';
import store from '@/store/index';
import StandardDataField from '@/components/StandardComponents/StandardDataField.component.vue'
import StandardDeleteBtn from '@/components/StandardComponents/StandardDeleteBtn.component.vue'
import { mapGetters, mapActions } from 'vuex';
export default {
  name: 'CompanyManage',
  components: {
    ButtonOutlined,
    StandardDataField,
    StandardDeleteBtn
  },
  data: function () {
    return {
      ppermission_search: '',
      bproletemplate_show_index: -1,
      add_is_active: false,
      new_role_name: '',
      new_role_description: ''

    }
  },
  created(){
    store.dispatch('ProjectMember/requestPPermissions', {
      project_id: 0
    });
    store.dispatch('Ultra/requestUObject', {
      url: [
        {businesses: this.getBusiness.id},
        {bproletemplates: ''},
        {showWithEntitiesNormalized: ''}
      ]
    });
  },
  computed: {
    ...mapGetters('Auth', [
      'getUser'
    ]),
    ...mapGetters('Ultra', [
      'getUObject',
      'getUObjects'
    ]),
    ...mapGetters('Business', [
      'getBusiness',
      'getAddMemberError',
      'getBusinessProjects',
      'getBusinessMembers',
      'getBusinessRoles',
      'hasBusinessPermission'
    ])
  },
  methods: {
    ...mapActions('Ultra', [
      'createUObject',
      'deleteUObject'
    ]),
    ...mapActions('Business', [
      'removeUsersFromBusiness',
      'addUsers',
      'removeUsers',
      'updateMemberBRole',
      'removeProjects',
      'resetAddMemberError',
      'removePPermissionToTemplate',
      'addPPermissionToTemplate',
      'updateInBusinessProjects',
    ]),
    addNewRole(){
      let self = this;
      this.createUObject({
        url: [
          { businesses: this.getBusiness.id },
          { bproletemplates: '' },
          { showWithEntitiesNormalized: '' }
        ],
        u_object: {
          name: self.new_role_name,
          description: self.new_role_description,
          ppermissions: []
        }
      }).then( () => {
        self.add_is_active = false;
        self.new_role_name = '';
        self.new_role_description = '';
      });
    },
    addAllPermissions(bproletemplate){
      this.getUObjects({type: 'allppermissions'}).forEach((ppermission) => {
        if(bproletemplate.ppermissions.indexOf(ppermission.id) === -1) {
          this.addPPermissionToTemplate({business_id: this.getBusiness.id, bproletemplate_id: bproletemplate.id, ppermission_id: ppermission.id});
        }
      });
    },
    removeAllPermissions(bproletemplate){
      this.getUObjects({type: 'allppermissions'}).forEach((ppermission) => {
        if(bproletemplate.ppermissions.indexOf(ppermission.id) !== -1) {
          this.removePPermissionToTemplate({business_id: this.getBusiness.id, bproletemplate_id: bproletemplate.id, ppermission_id: ppermission.id})
        }
      });
    },
  }
}
</script>

<style lang="scss" scoped>
.members-setting-default-height {
  max-height: 600px;
  overflow-y: auto;
}
.list-item-bg {
  background-color: red;
}
</style>
